import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const OrderBook = ({ selectedCrypto }) => {
  const [view, setView] = useState('both');

  const buyOrders = [
    { price: 42945, amount: 0.5234, total: 22467.23 },
    { price: 42940, amount: 1.2456, total: 53478.34 },
    { price: 42935, amount: 0.8923, total: 38312.45 },
    { price: 42930, amount: 2.1234, total: 91145.67 },
    { price: 42925, amount: 0.6789, total: 29134.56 },
    { price: 42920, amount: 1.4567, total: 62523.78 },
    { price: 42915, amount: 0.9876, total: 42389.12 },
    { price: 42910, amount: 1.7654, total: 75789.45 }
  ];

  const sellOrders = [
    { price: 42950, amount: 0.7654, total: 32876.43 },
    { price: 42955, amount: 1.3456, total: 57789.23 },
    { price: 42960, amount: 0.5678, total: 24389.45 },
    { price: 42965, amount: 1.8923, total: 81267.89 },
    { price: 42970, amount: 0.9234, total: 39678.12 },
    { price: 42975, amount: 1.5678, total: 67389.56 },
    { price: 42980, amount: 0.8456, total: 36345.67 },
    { price: 42985, amount: 2.1234, total: 91278.34 }
  ];

  const OrderRow = ({ order, type }) => {
    const percentage = (order?.amount / 3) * 100;
    
    return (
      <div className="relative group">
        <div
          className={`absolute inset-0 ${
            type === 'buy' ? 'bg-success/10' : 'bg-error/10'
          }`}
          style={{ width: `${percentage}%` }}
        />
        <div className="relative grid grid-cols-3 gap-2 px-3 py-1.5 text-xs md:text-sm hover:bg-muted/50 transition-colors">
          <span className={`font-medium ${type === 'buy' ? 'text-success' : 'text-error'}`}>
            {order?.price?.toLocaleString()}
          </span>
          <span className="text-foreground text-right">{order?.amount?.toFixed(4)}</span>
          <span className="text-muted-foreground text-right">{order?.total?.toLocaleString()}</span>
        </div>
      </div>
    );
  };

  return (
    <div className="bg-card rounded-lg border border-border h-full flex flex-col">
      <div className="flex items-center justify-between p-4 border-b border-border">
        <h3 className="text-base md:text-lg font-semibold text-foreground">Order Book</h3>
        <div className="flex items-center gap-1 bg-muted rounded-lg p-1">
          <button
            onClick={() => setView('both')}
            className={`p-1.5 rounded transition-colors ${
              view === 'both' ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:text-foreground'
            }`}
            aria-label="Show both buy and sell orders"
          >
            <Icon name="List" size={16} />
          </button>
          <button
            onClick={() => setView('buy')}
            className={`p-1.5 rounded transition-colors ${
              view === 'buy' ? 'bg-success text-white' : 'text-muted-foreground hover:text-foreground'
            }`}
            aria-label="Show buy orders only"
          >
            <Icon name="ArrowDown" size={16} />
          </button>
          <button
            onClick={() => setView('sell')}
            className={`p-1.5 rounded transition-colors ${
              view === 'sell' ? 'bg-error text-white' : 'text-muted-foreground hover:text-foreground'
            }`}
            aria-label="Show sell orders only"
          >
            <Icon name="ArrowUp" size={16} />
          </button>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-2 px-3 py-2 text-xs text-muted-foreground border-b border-border">
        <span>Price (USD)</span>
        <span className="text-right">Amount ({selectedCrypto?.symbol})</span>
        <span className="text-right">Total (USD)</span>
      </div>
      <div className="flex-1 overflow-y-auto">
        {(view === 'both' || view === 'sell') && (
          <div className="flex flex-col-reverse">
            {sellOrders?.map((order, index) => (
              <OrderRow key={`sell-${index}`} order={order} type="sell" />
            ))}
          </div>
        )}

        {view === 'both' && (
          <div className="flex items-center justify-center gap-2 py-3 bg-muted/30">
            <span className="text-xl md:text-2xl font-bold text-foreground">
              {selectedCrypto?.price}
            </span>
            <Icon 
              name={selectedCrypto?.change >= 0 ? 'TrendingUp' : 'TrendingDown'} 
              size={20} 
              color={selectedCrypto?.change >= 0 ? 'var(--color-success)' : 'var(--color-error)'} 
            />
          </div>
        )}

        {(view === 'both' || view === 'buy') && (
          <div>
            {buyOrders?.map((order, index) => (
              <OrderRow key={`buy-${index}`} order={order} type="buy" />
            ))}
          </div>
        )}
      </div>
      <div className="p-4 border-t border-border">
        <div className="flex items-center justify-between text-xs md:text-sm">
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-success" />
            <span className="text-muted-foreground">Bid Volume:</span>
            <span className="font-medium text-foreground">
              {buyOrders?.reduce((sum, order) => sum + order?.amount, 0)?.toFixed(4)}
            </span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-error" />
            <span className="text-muted-foreground">Ask Volume:</span>
            <span className="font-medium text-foreground">
              {sellOrders?.reduce((sum, order) => sum + order?.amount, 0)?.toFixed(4)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderBook;